import { MailboxInfo } from 'owa-client-ids';
import { trace } from 'owa-trace';
import { getConnectorsLTIToken } from 'owa-connectors';

const DATA_PREFIX = 'data:';
const BLOB_PREFIX = 'blob:';

export default function fixExternalInlineImages(
    cardElement: HTMLElement,
    mailboxInfo: MailboxInfo
) {
    const externalImgElements = cardElement.querySelectorAll('img:not([src^="cid:"])');
    if (externalImgElements) {
        for (let i = 0; i < externalImgElements.length; i++) {
            // don't apply changes for data urls
            if (
                (<HTMLImageElement>externalImgElements[i]).src.indexOf(DATA_PREFIX) !== 0 &&
                (<HTMLImageElement>externalImgElements[i]).src.indexOf(BLOB_PREFIX) !== 0
            ) {
                fixSrcForExternalImage(
                    <HTMLImageElement>externalImgElements[i],
                    mailboxInfo.mailboxSmtpAddress
                );
            }
        }
    }
}

async function fixSrcForExternalImage(img: HTMLImageElement, mailboxId: string) {
    try {
        await getConnectorsLTIToken();
        img.src = `/actions/${mailboxId}/th?u=${encodeURIComponent(img.src)}`;
    } catch (error) {
        trace.warn('[fixSrcForExternalImage] Error setting src value. Exception: ' + error.message);
    }
}
